import { modulesPart1 } from "./modules1";
import { modulesPart2 } from "./modules2";

export const MODULES = [...modulesPart1, ...modulesPart2];
export const getModule = (slug) => MODULES.find((m) => m.slug === slug);
export const YOUTUBE_URL = "https://www.youtube.com/@dioptremedia";
export const STICKY = {
  yellow: "#FFF1A8",
  green: "#CFF5DC",
  pink: "#FFD6E7",
  blue: "#CDEBFF",
  purple: "#E6DAFF",
  orange: "#FFDDBE",
};
